import React, { ReactElement, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router";
import { AuthorizationVerifier } from "../../components/authorization-verifier";
import queryString from "query-string";
import { SVGMenu } from "./assets";
import {useTheme} from "styled-components";
import { IPropertyChainData, useChainData } from "../../components/chain-data-provider";

export interface MenuItemProps {
  href?: string;
  route?: string;
  message: {
    id: string;
    defaultMessage: string;
  };
  target?: string;
  section?: string;
  icon?: string;
  hideItem?: false;
  children?: ReactElement;
}

export function MenuItem({ href, route, message, target, section, icon }: MenuItemProps) {
  const history = useHistory();
  const isLegacy = !!href;
  const theme = useTheme();

  const handleClick = useCallback(() => {
    if (route) {
      history.push(route);
    } else {
      console.error("No route and no href on menu item. Will do nothing.");
    }
  }, [history, route]);

  return (
    <AuthorizationVerifier section={section} showForbiddenMessage={false}>
      <div className={`p-2 hover:bg-[${theme.greyBackground}]`}>
        <a
          className="cursor-pointer hover:no-underline flex justify-start items-center "
          href={isLegacy ? href : undefined}
          onClick={isLegacy ? undefined : handleClick}
          target={target}>
          {icon && SVGMenu[icon]}
          <span className={`${!!icon && "pl-2"} text-[${theme.textColor}] hover:text-[${theme.buttonColor}]`}>
            <FormattedMessage {...message} />
          </span>
        </a>
      </div>
    </AuthorizationVerifier>
  );
}

export function CallCenterLoyalty({
  message,
  propertyTicker,
  userProfile,
  engineBaseUrl,
  loyaltyBrand,
  icon,
}: any) {
  const chainData: IPropertyChainData | undefined | null = useChainData();
  const mainDomain = loyaltyBrand && loyaltyBrand.mainDomain;
  const engineDomain = mainDomain ? `https://${mainDomain}` : engineBaseUrl;
  const engineUrl = queryString.stringifyUrl({
    url: `${engineDomain}/${chainData?.isChain ? "chain" : "hotel"}/${propertyTicker}`,
    query: {
      encodedAffiliate: userProfile ? btoa(userProfile.email || "") : undefined,
      origin: "callcenter",
      disableAbTest: "1",
    },
  });
  return (
    <div className="flex justify-start items-center p-2 hover:bg-gray-100 text-[#5C5C5C]">
      {icon && SVGMenu[icon]}
      <span className="hover:text-[#2E3862]">
        <a
          className="text-[#5C5C5C] pl-2 cursor-pointer hover:no-underline "
          href={engineUrl}
          target="_blank"
          rel="noopener noreferrer">
          <FormattedMessage {...message} />
        </a>
      </span>
    </div>
  );
}
